module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ClaimFlow"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('p', {
    staticClass: "title2"
  }, [_vm._v("用户在使用WiFi万能钥匙连接网络的过程中，发现银行账户资金(用户本人在银行账户内的资产，及用户在合法运营的第三方支付机构所设本人实名制账户中的资产)遭受损失，应立即采取以下措施:")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v("1.保全证据")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("发现损失后，立即采取相关证据保全措施，不应自行刷机、清理手机垃圾、删除WiFi万能钥匙客户端、历史短信或历史访问网址记录，或自行删除交易过程中与对方的聊天记录以及所下载软件，以免导致相关证据无法保全；")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v("2.报案")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("在保全证据后，立即拨打保险公司电话进行报案，并于10个自然日内前往用户住所地或经常居住地有管辖权的公安机关进行报案，并取得案件受理通知书等相关证明材料；")]), _vm._v(" "), _c('p', {
    staticClass: "text highlight"
  }, [_vm._v("众安保险客服电话:400-999-9595")]), _vm._v(" "), _c('p', {
    staticClass: "text highlight"
  }, [_vm._v("(7X24小时统一客服热线)")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v("3.准备索赔资料")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("用户应自使用WiFi万能钥匙遭受直接经济损失之日起15个自然日内，根据WiFi万能钥匙官网或者手机客户端索赔界面的提示准备索赔资料。并听从工作人员的操作指导，配合提供相关损失的证明文件，以便有效核实被盗情况。")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("若保险公司或WiFi万能钥匙的工作人员联系用户时，自首次尝试联系用户起72小时内无法与用户取得联系，将视用户自动放弃索赔。")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v("4.提交索赔资料")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("用户应自使用WiFI万能钥匙遭受直接经济损失之日起15个自然日内，根据保险公司工作人员的指示，将索赔资料快递至以下地址(不接受快递到付)，并确保其所提交资料的真实性。配合提供相关损失的证明文件，以便有效核实被盗情况。")]), _vm._v(" "), _c('p', {
    staticClass: "text highlight"
  }, [_vm._v("\n          收件人:WiFi万能钥匙用户安全理赔项目组"), _c('br'), _vm._v("\n          快递联系电话:400-035-8000"), _c('br'), _vm._v("\n          寄送地址:上海市浦东新区张衡路666弄1号楼7楼\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v("5.理赔结果")]), _vm._v(" "), _c('p', {
    staticClass: "text last"
  }, [_vm._v("保险公司根据用户提交的材料将认定最终理赔结果，如最终确认属于理赔责任范围内的情形，由保险公司向用户支付赔款，最终理赔额在人民币3000元(含3000元)以下的案件由保险公司在确认最终理赔结果后的5个工作日内支付赔款；最终理赔额在人民币3000元以上的案件由保险公司在确认最终理赔结果后的10个工作日之内支付赔款。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fd2ed5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClaimFlow.vue
// module id = 825
// module chunks = 1